module.exports = __webpack_public_path__ + "img/aboutUs_img10.bc7f99ce.svg";